// Hooks/useTablonAnuncios.js
import { useState, useEffect } from 'react'
import useMqttSubscription from './useMqttSubscription'
import { UrlApi } from '../services/apirest'

// ── Singleton de estado — todo en un solo objeto ──────────────────────────────
let listeners = []
let storeState = { anuncios: [], noLeidos: 0, cargando: true, enviados: [] }
let fetchHecho = false

function notificarListeners() {
    listeners.forEach(fn => fn({ ...storeState }))
}

async function fetchAnuncios(username) {
    try {
        const res = await fetch(`${UrlApi}/tablon-anuncios?username=${username}`)
        const json = await res.json()
        storeState = { ...storeState, anuncios: json.data, noLeidos: json.noLeidos, cargando: false }
        notificarListeners()
    } catch (err) {
        console.error('[Tablon] Error al cargar anuncios:', err)
        storeState = { ...storeState, cargando: false }
        notificarListeners()
    }
}

async function fetchEnviados(username) {
    try {
        const res = await fetch(`${UrlApi}/tablon-anuncios/enviados?username=${username}`)
        const json = await res.json()
        storeState = { ...storeState, enviados: json.data }  // ⬅️ dentro del mismo storeState
        notificarListeners()
    } catch (err) {
        console.error('[Tablon] Error al cargar enviados:', err)
    }
}

async function marcarVisto(anuncio_id, username) {
    try {
        await fetch(`${UrlApi}/tablon-anuncios/visto`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ anuncio_id, username })
        })
        storeState = {
            ...storeState,
            anuncios: storeState.anuncios.map(a =>
                a.id === anuncio_id ? { ...a, visto: 1 } : a
            ),
            noLeidos: Math.max(0, storeState.noLeidos - 1)
        }
        notificarListeners()
    } catch (err) {
        console.error('[Tablon] Error al marcar como visto:', err)
    }
}

export function resetTablonStore() {
    fetchHecho = false
    storeState = { anuncios: [], noLeidos: 0, cargando: true, enviados: [] }
    notificarListeners()
}

// ── Hook principal ────────────────────────────────────────────────────────────
export function useTablonAnuncios() {
    const username = localStorage.getItem('user')
    const sector = localStorage.getItem('sector')
    const [data, setData] = useState(storeState)

    const handleMqttMessage = (payload) => {
        console.log('[Tablon] Mensaje recibido:', payload)
        // ⬅️ Si es una notificación de lectura, refrescamos enviados
        if (payload.evento === 'anuncio_visto') {
            fetchEnviados(username)
            return
        }
        if (payload.tipo === 'individual' && payload.username_dest !== username) {
            return
        }
        fetchAnuncios(username)
    }

    useMqttSubscription(`sistema/anuncios`, handleMqttMessage)
    useMqttSubscription(`sistema/user/${username}`, handleMqttMessage)
    useMqttSubscription(`sistema/sector/${sector}`, handleMqttMessage)

    useEffect(() => {
        listeners.push(setData)

        // ⬅️ Siempre fetchea si el username está disponible
        if (!fetchHecho || username) {
            fetchHecho = true
            fetchAnuncios(username)
        }

        return () => {
            listeners = listeners.filter(fn => fn !== setData)
        }
    }, [username])

    return {
        anuncios: data.anuncios,
        noLeidos: data.noLeidos,
        cargando: data.cargando,
        enviados: data.enviados,
        marcarVisto: (anuncio_id) => marcarVisto(anuncio_id, username),
        refetch: () => fetchAnuncios(username),
        refetchEnviados: () => fetchEnviados(username),
    }
}